function makeObjectsUniqueWithMap<T extends object>(arr: T[], keyExtractor: (obj: T) => any): T[] {
  const seen = new Map()
  const uniqueArray: T[] = []

  for (const obj of arr) {
    const key = keyExtractor(obj)
    if (!seen.has(key)) {
      seen.set(key, obj)
      uniqueArray.push(obj)
    }
  }

  return uniqueArray
}

export { makeObjectsUniqueWithMap }
